import { styled } from '@mui/material/styles';
import { StyledTradesTable } from './styled-trades-table';

interface StyledClickableTradesTableProps {
  isClickable?: boolean;
}

export const StyledClickableTradesTable = styled(StyledTradesTable, {
  shouldForwardProp: (prop) => prop !== 'isClickable',
})<StyledClickableTradesTableProps>(({ isClickable }) => ({
  ...(isClickable && {
    '& .MuiDataGrid-row': {
      cursor: 'pointer',
    },
  }),
}));
